(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.resi.controller-stockholm-living
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:holding-name       (:holding-name report-data)
   :reference-date     (get-in report-data [:reference-date])
   :report-id          (:report-id props)
   :portfolio-summary-text (report-ctl/rich-content props :portfolio-summary-text)
   :overview           (report-ctl/with-footnote
                         props
                         :overview-footnotes
                         (get-in report-data [:basic-information-primary]))
   :portfolio-overview (report-ctl/with-footnote
                         props
                         :overview-table-footnotes
                         (:portfolio-overview report-data))
   :energy-performance-certificate-at-acquisition (get-in dynamic-data [:energy-performance-certificate-at-acquisition])
   :energy-performance-certificate-target (get-in dynamic-data [:energy-performance-certificate-target])
   :energy-performance-status    (report-ctl/rich-content props :energy-performance-status)
   :green-building-certification (get-in dynamic-data [:green-building-certification])
   :green-building-status        (report-ctl/rich-content props :green-building-status)
   :eu-taxonomy-alignment        (get-in dynamic-data [:eu-taxonomy-alignment])
   :eu-taxonomy-plan             (report-ctl/rich-content props :eu-taxonomy-plan)
   :other-esg-development        (report-ctl/rich-content props :other-esg-development)})
